/**
 * Lembra quais tours de novidades (FeatureTourCmp) o usuario ja viu.
 *
 * A chave NAO pode conter "muven-": o interceptor de autenticacao
 * (src/auth/interceptors/registerAuthInterceptor.ts) injeta como header HTTP toda chave
 * de localStorage que casa com /muven-/.
 *
 * Valor: JSON `{ [idDoTour]: versao }`. Mudou a tela de novo? Suba a `version` do tour
 * em src/utils/tours/FeatureTours.ts e ele reaparece para todo mundo.
 *
 * Nada limpa essa chave - o logout so remove `muven-client-id` -, entao e por navegador.
 */
const FEATURE_TOUR_SEEN = 'feature-tour-seen'

function readAll():{[id:string]:number} {
    const raw = localStorage.getItem(FEATURE_TOUR_SEEN)

    if (!raw) {
        return {}
    }

    try {
        const parsed = JSON.parse(raw)

        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
    } catch (e) {
        return {}
    }
}

export default {
    hasSeen(id:string, version:number):boolean {
        try {
            const seen = readAll()[id]

            return typeof seen === 'number' && seen >= version
        } catch (e) {
            // storage indisponivel: melhor nao mostrar do que mostrar em toda visita
            return true
        }
    },
    markSeen(id:string, version:number):void {
        try {
            const all = readAll()
            all[id] = version
            localStorage.setItem(FEATURE_TOUR_SEEN, JSON.stringify(all))
        } catch (e) {
            // sem persistencia o tour so volta a aparecer na proxima visita
        }
    },
    reset(id:string):void {
        try {
            const all = readAll()
            delete all[id]
            localStorage.setItem(FEATURE_TOUR_SEEN, JSON.stringify(all))
        } catch (e) {
            // nada a fazer
        }
    },
}
